(function () {
  function parseJson(script) {
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      console.error('Bundle builder offer: JSON parse failed', e);
      return null;
    }
  }

  function generateBundleInstanceId() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID().replace(/-/g, '');
    }
    return Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }

  function generateBundleId(group, instanceId) {
    return `${group || 'Schulstarter'}-${instanceId || generateBundleInstanceId()}`;
  }

  function bundleLineProperties(bundleId, parentVariantId, bundleTitle, bundleGroup, instanceId, extra) {
    const props = { _BundleId: bundleId };
    if (bundleGroup) props._BundleGroup = bundleGroup;
    if (instanceId) props._BundleInstance = instanceId;
    if (bundleGroup && instanceId) {
      props._DiscountId = `${bundleGroup}-${instanceId}`;
    } else if (bundleId) {
      props._DiscountId = bundleId;
    }
    if (parentVariantId) props._BundleParentVariantId = String(parentVariantId);
    if (bundleTitle) props._BundleTitle = bundleTitle;
    if (extra && typeof extra === 'object') {
      Object.keys(extra).forEach((key) => {
        if (extra[key] != null && extra[key] !== '') props[key] = String(extra[key]);
      });
    }
    return props;
  }

  class BundleBuilderOffer extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.groups = parseJson(this.querySelector('[data-offer-groups]')) || [];
      this.groups.forEach((group) => {
        group.index = parseInt(group.index, 10);
      });
      this.gifts = parseJson(this.querySelector('[data-offer-gifts]')) || [];
      this.bundleGroup = this.getAttribute('data-bundle-group') || 'Schulstarter';
      this.bundleTitle = this.getAttribute('data-bundle-title') || 'Schulstarter-Kit';
      this.kitVariantId = parseInt(this.getAttribute('data-kit-variant-id'), 10) || 0;
      this.redirectToCheckout = this.getAttribute('data-redirect-to-checkout') === 'true';
      this.atcSuccessMessage = this.getAttribute('data-atc-success-message') || '🎉 Auswahl komplett!';
      this.colorsPlaceholder = this.getAttribute('data-colors-placeholder') || 'Geschenk auswählen...';
      this.enableCustomCompare = this.getAttribute('data-enable-custom-compare') === 'true';
      this.customCompareCents = parseInt(this.getAttribute('data-custom-compare'), 10) || 0;
      this.displayFinalCents = parseInt(this.getAttribute('data-display-final'), 10) || 0;
      this.displayCompareCents = parseInt(this.getAttribute('data-display-compare'), 10) || 0;
      this.orderDiscountPercent = parseFloat(this.getAttribute('data-order-discount-percent')) || 0;
      this.flexibleQuantity = this.getAttribute('data-flexible-quantity') === 'true';
      this.flexibleMaxQuantity = parseInt(this.getAttribute('data-flexible-max'), 10) || 4;
      this.qtyDiscountThreshold = parseInt(this.getAttribute('data-qty-discount-threshold'), 10) || 2;
      this.qtyDiscountPercent = parseFloat(this.getAttribute('data-qty-discount-percent')) || 0;
      this.qtyDiscountPercent3 = parseFloat(this.getAttribute('data-qty-discount-percent-3')) || 0;
      this.qtyDiscountPercent4 = parseFloat(this.getAttribute('data-qty-discount-percent-4')) || 0;
      this.optionalSlotLabel =
        this.getAttribute('data-optional-slot-label') || 'Wähle 1x weitere für 10% sparen';
      this.cappedGroupIndexes = this._parseIndexList(this.getAttribute('data-cap-groups-to-group-1'));
      if (this.bundleGroup === 'LunchboxSet' && !this.cappedGroupIndexes.length) {
        this.cappedGroupIndexes = [3];
      }
      this.groups.forEach((group) => {
        if (this.cappedGroupIndexes.includes(group.index)) group.limitToGroup = 1;
      });
      this.qtyDiscountTiers = [
        { qty: this.qtyDiscountThreshold || 2, percent: this.qtyDiscountPercent },
        { qty: 3, percent: this.qtyDiscountPercent3 },
        { qty: 4, percent: this.qtyDiscountPercent4 }
      ]
        .filter((tier) => tier.qty > 0 && tier.percent > 0)
        .sort((a, b) => a.qty - b.qty);

      this.selections = {};
      this.declined = {};
      this.groups.forEach((group) => {
        const min = this._groupMin(group);
        this.selections[group.index] = this.flexibleQuantity
          ? new Array(min).fill(null)
          : new Array(group.quantity).fill(null);
      });
      this.giftSelections = {};

      this.groupsPanel = this.querySelector('[data-offer-groups-panel]');
      this.giftSlotsEl = this.querySelector('[data-offer-gift-slots]');
      this.slotTemplate = this.querySelector('[data-offer-slot-template]');
      this.atcButton = this.querySelector('[data-offer-atc]');
      this.atcToast = this.querySelector('[data-offer-atc-toast]');

      this.drawer = document.getElementById(this.getAttribute('data-drawer-id'));
      this.drawerList = this.drawer?.querySelector('[data-offer-drawer-list]');
      this.drawerTitle = this.drawer?.querySelector('[data-offer-drawer-title]');
      this.drawerConfirm = this.drawer?.querySelector('[data-offer-drawer-confirm]');
      this.drawerConfirmTitle = this.drawer?.querySelector('[data-offer-drawer-confirm-title]');
      this.drawerConfirmCount = this.drawer?.querySelector('[data-offer-drawer-confirm-count]');
      this.drawerPrices = this.drawer?.querySelector('[data-offer-drawer-prices]');
      this.drawerTotal = this.drawer?.querySelector('[data-offer-drawer-total]');
      this.drawerCompare = this.drawer?.querySelector('[data-offer-drawer-compare]');
      this.drawerDiscountBadge = this.drawer?.querySelector('[data-offer-drawer-discount-badge]');
      this.drawerProgress = this.drawer?.querySelector('[data-offer-drawer-progress]');
      this.drawerProgressText = this.drawer?.querySelector('[data-offer-drawer-progress-text]');
      this.drawerProgressBadge = this.drawer?.querySelector('[data-offer-drawer-progress-badge]');
      this.drawerCapHint = this.drawer?.querySelector('[data-offer-drawer-cap-hint]');
      this.qtyProgress = this.querySelector('[data-offer-qty-progress]');
      this.qtyProgressText = this.querySelector('[data-offer-qty-progress-text]');
      this.qtyProgressBadge = this.querySelector('[data-offer-qty-progress-badge]');
      this.qtyTemplate = this.querySelector('[data-offer-qty-template]');
      this.colorsDrawer = document.getElementById(this.getAttribute('data-colors-drawer-id'));
      this.colorsList = this.colorsDrawer?.querySelector('[data-offer-colors-list]');
      this.colorsTitle = this.colorsDrawer?.querySelector('[data-offer-colors-title]');
      this.colorsConfirm = this.colorsDrawer?.querySelector('[data-offer-colors-confirm]');

      this.activeGroupIndex = null;
      this.drawerQuantities = {};
      this.activeGiftSlot = null;
      this.pendingGiftVariantId = null;

      this._bindEvents();
      this._renderGroups();
      this._renderGiftSlots();
      this._autoFillSingleVariantProductGroups();
      this._autoFillSingleVariantGifts();
      this._updateUi();
    }

    _parseIndexList(value) {
      return String(value || '')
        .split(',')
        .map((part) => parseInt(part.trim(), 10))
        .filter((index) => index > 0);
    }

    _groupMin(group) {
      const min = parseInt(group.quantity, 10) || 0;
      if (this.flexibleQuantity) return Math.max(0, min);
      return Math.max(1, min);
    }

    _groupMax(group) {
      if (!this.flexibleQuantity) return this._groupMin(group);
      let max = parseInt(group.maxQuantity, 10) || this.flexibleMaxQuantity || 4;
      if (this._isCappedGroup(group)) {
        const anchor = this._anchorGroup();
        const anchorQty = anchor ? this._filledCount(anchor) : 0;
        return Math.min(max, anchorQty);
      }
      return Math.max(this._groupMin(group), max);
    }

    _isCappedGroup(group) {
      return parseInt(group?.limitToGroup, 10) === 1;
    }

    _anchorGroup() {
      return this.groups.find((entry) => entry.index === 1) || null;
    }

    _groupShortName(group) {
      return String(group?.heading || '')
        .replace(/^\d+\.\s*/, '')
        .replace(/^Wähle (deine|dein|deinen)\s+/i, '')
        .trim();
    }

    _capMessage(group) {
      const anchor = this._anchorGroup();
      const anchorName = this._groupShortName(anchor) || 'Lunchbox';
      const groupName = this._groupShortName(group) || 'Produkt';
      if (!anchor || this._filledCount(anchor) < 1) {
        return `Wähle zuerst eine ${anchorName}, um ${groupName} auszuwählen.`;
      }
      return `Wähle eine weitere ${anchorName}, um mehr ${groupName} auszuwählen.`;
    }

    _enforceQuantityCaps() {
      if (!this.flexibleQuantity || !this.cappedGroupIndexes.length) return;
      this.cappedGroupIndexes.forEach((index) => {
        const group = this.groups.find((entry) => entry.index === index);
        if (!group) return;
        const max = this._groupMax(group);
        const filled = this._compactSelections(group);
        if (filled.length > max) {
          this.selections[index] = filled.slice(0, max);
        }
      });
    }

    _filledCount(group) {
      return (this.selections[group.index] || []).filter(Boolean).length;
    }

    _compactSelections(group) {
      return (this.selections[group.index] || []).filter(Boolean);
    }

    _totalFilledQty() {
      return this.groups.reduce((sum, group) => {
        if (group.isGoodie) return sum;
        return sum + this._filledCount(group);
      }, 0);
    }

    _discountPercentForQty(qty) {
      let percent = 0;
      this.qtyDiscountTiers.forEach((tier) => {
        if (qty >= tier.qty) percent = tier.percent;
      });
      return percent;
    }

    _nextDiscountTier(qty) {
      return this.qtyDiscountTiers.find((tier) => tier.qty > qty) || null;
    }

    _volumeProgress(qty) {
      const next = this._nextDiscountTier(qty);
      if (!next) return null;
      return {
        remaining: next.qty - qty,
        progressText: `Noch ${next.qty - qty} für`,
        badgeText: `${Math.round(next.percent)}% RABATT`
      };
    }

    _setProgress(banner, textEl, badgeEl, progress) {
      if (!banner) return;
      if (!progress) {
        banner.hidden = true;
        return;
      }
      banner.hidden = false;
      if (textEl) textEl.textContent = progress.progressText || '';
      if (badgeEl) {
        badgeEl.textContent = progress.badgeText || '';
        badgeEl.hidden = !progress.badgeText;
      }
    }

    _optionalLabel() {
      const next = this._nextDiscountTier(this._totalFilledQty());
      if (!next) return 'Weitere auswählen...';
      if (next.qty - this._totalFilledQty() === 1 && this.optionalSlotLabel) {
        if (this._totalFilledQty() < this.qtyDiscountThreshold) return this.optionalSlotLabel;
        return `Wähle 1x weitere für ${next.percent}% sparen`;
      }
      return `Wähle ${next.qty - this._totalFilledQty()} weitere für ${next.percent}% sparen`;
    }

    _bindEvents() {
      this.atcButton?.addEventListener('click', () => this._addToCart());
      this.colorsConfirm?.addEventListener('click', () => this._confirmGiftColor());
      this.drawerConfirm?.addEventListener('click', () => this._confirmGroupDrawer());

      this.drawerList?.addEventListener('click', (e) => {
        if (e.target.closest('[data-offer-decline]')) {
          e.preventDefault();
          this.drawerNone = true;
          this.drawerQuantities = {};
          this._syncDrawerQtyDisplay();
          return;
        }
        const minus = e.target.closest('[data-qty-minus]');
        const plus = e.target.closest('[data-qty-plus]');
        if (!minus && !plus) return;
        const item = e.target.closest('[data-drawer-item]');
        const variantId = parseInt(item?.getAttribute('data-variant-id'), 10);
        if (!variantId) return;
        this._changeDrawerQty(variantId, plus ? 1 : -1);
      });

      this.drawerList?.addEventListener('keydown', (e) => {
        if (e.target.matches('[data-qty-value]')) e.preventDefault();
      });

      this.drawer?.addEventListener('dialog:after-hide', () => {
        this.drawerQuantities = {};
      });
    }

    _renderGroups() {
      if (!this.groupsPanel || !this.slotTemplate) return;
      this.groupsPanel.innerHTML = '';

      this.groups.forEach((group) => {
        const section = document.createElement('div');
        section.className = 'bk-media-bundle-builder-offer__step';
        section.setAttribute('data-offer-group', String(group.index));

        if (group.heading) {
          const heading = document.createElement('p');
          heading.className = 'bk-media-bundle-builder-offer__step-heading bk-media-bundle-builder__cards-heading bold';
          heading.textContent = group.heading;
          section.appendChild(heading);
        }

        const panel = document.createElement('div');
        panel.className = 'bk-media-bundle-builder-offer__group';

        const slots = document.createElement('div');
        slots.className = 'bk-media-bundle-builder__slots v-stack gap-3';
        slots.setAttribute('data-offer-slots', String(group.index));
        section.appendChild(panel);
        panel.appendChild(slots);
        this.groupsPanel.appendChild(section);
        this._renderGroupSlots(group);
      });
    }

    _renderGroupSlots(group) {
      const slots = this.querySelector(`[data-offer-slots="${group.index}"]`);
      if (!slots || !this.slotTemplate) return;
      slots.innerHTML = '';

      if (this.declined[group.index] && this._filledCount(group) === 0) {
        const node = this.slotTemplate.content.cloneNode(true);
        const wrap = node.querySelector('[data-bundle-slot-wrap]');
        const btn = node.querySelector('[data-offer-open-slot]');
        const removeBtn = node.querySelector('[data-offer-slot-remove]');
        const label = node.querySelector('[data-slot-label]');
        const imgWrap = node.querySelector('[data-slot-image]');
        btn?.classList.add('is-filled');
        if (label) {
          label.textContent = group.noneLabel;
          label.classList.remove('text-subdued');
        }
        if (imgWrap && group.placeholderImage) {
          imgWrap.innerHTML = `<img src="${group.placeholderImage}" alt="" loading="lazy" width="60" height="60">`;
        }
        const check = wrap?.querySelector('[data-slot-check]');
        if (check) check.setAttribute('aria-hidden', 'false');
        if (removeBtn) removeBtn.hidden = false;
        btn?.addEventListener('click', () => this._openGroupDrawer(group.index));
        removeBtn?.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.declined[group.index] = false;
          this._updateUi();
        });
        slots.appendChild(node);
        return;
      }

      const max = this._groupMax(group);
      const min = this._groupMin(group);
      const filled = this._compactSelections(group);
      const rowItems = this.flexibleQuantity
        ? filled
        : this.selections[group.index] || [];
      let slotCount = this.flexibleQuantity ? Math.max(filled.length, min, 1) : min;
      if (this.flexibleQuantity && filled.length > 0 && filled.length < max) {
        slotCount = filled.length + 1;
      } else if (this.flexibleQuantity && filled.length === 0) {
        slotCount = Math.max(1, min);
      } else if (this.flexibleQuantity) {
        slotCount = filled.length;
      }
      const showOptional =
        this.flexibleQuantity && filled.length > 0 && filled.length < max && slotCount > filled.length;

      for (let i = 0; i < slotCount; i++) {
        const isOptional = showOptional && i >= filled.length;
        const node = this.slotTemplate.content.cloneNode(true);
        const wrap = node.querySelector('[data-bundle-slot-wrap]');
        const btn = node.querySelector('[data-offer-open-slot]');
        const removeBtn = node.querySelector('[data-offer-slot-remove]');
        const label = node.querySelector('[data-slot-label]');
        const imgWrap = node.querySelector('[data-slot-image]');
        const sel = rowItems[i] || null;

        if (isOptional) btn?.classList.add('is-optional');
        if (label) {
          label.textContent = isOptional
            ? this._optionalLabel()
            : group.placeholder || 'Produkt auswählen...';
        }
        if (imgWrap && group.placeholderImage) {
          imgWrap.innerHTML = `<img src="${group.placeholderImage}" alt="" loading="lazy" width="60" height="60">`;
        }

        btn?.addEventListener('click', () => this._openGroupDrawer(group.index));
        removeBtn?.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this._clearSlot(group.index, i);
        });

        wrap?.setAttribute('data-group-index', String(group.index));
        wrap?.setAttribute('data-slot-index', String(i));
        if (isOptional) wrap?.setAttribute('data-optional', 'true');
        slots.appendChild(node);

        if (sel) {
          btn?.classList.add('is-filled');
          if (label) {
            label.textContent = sel.title;
            label.classList.remove('text-subdued');
          }
          if (imgWrap && sel.image) {
            imgWrap.innerHTML = `<img src="${sel.image}" alt="" loading="lazy" width="60" height="60">`;
          }
          const check = wrap?.querySelector('[data-slot-check]');
          if (check) check.setAttribute('aria-hidden', 'false');
          if (removeBtn) removeBtn.hidden = false;
        }
      }
    }

    _renderGiftSlots() {
      if (!this.giftSlotsEl || !this.gifts.length) return;
      this.giftSlotsEl.innerHTML = '';

      this.gifts.forEach((gift) => {
        const wrap = document.createElement('div');
        wrap.className = 'bk-media-bundle-builder__slot-wrap';
        wrap.setAttribute('data-gift-slot-wrap', String(gift.slot));

        const needsPicker = gift.variants.length > 1;
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bk-media-bundle-builder__slot';
        btn.setAttribute('data-offer-gift-slot', String(gift.slot));

        const img = document.createElement('span');
        img.className = 'bk-media-bundle-builder__slot-image';
        img.setAttribute('data-gift-slot-image', '');
        if (gift.image) {
          img.innerHTML = `<img src="${gift.image}" alt="" loading="lazy" width="60" height="60">`;
        }

        const box = document.createElement('span');
        box.className = 'bk-media-bundle-builder__slot-box v-stack gap-0.5 align-start';
        const titleRow = document.createElement('span');
        titleRow.className = 'bk-media-bundle-builder__slot-title-row h-stack gap-2 align-center';
        const title = document.createElement('span');
        title.className = 'text-sm bold';
        title.textContent = gift.title;
        titleRow.appendChild(title);
        if (gift.showCompareAt !== false && gift.compareAt > 0) {
          const compare = document.createElement('span');
          compare.className = 'bk-media-bundle-builder__kit-gift-compare text-subdued text-sm line-through';
          compare.textContent = this._formatMoney(gift.compareAt);
          titleRow.appendChild(compare);
        }
        const label = document.createElement('span');
        label.className = 'text-subdued text-sm';
        label.setAttribute('data-gift-slot-label', '');
        label.textContent = needsPicker ? this.colorsPlaceholder : '';
        if (!needsPicker) label.hidden = true;

        box.appendChild(titleRow);
        box.appendChild(label);

        const check = document.createElement('span');
        check.className = 'bk-media-bundle-builder__slot-check';
        check.setAttribute('data-slot-check', '');
        check.setAttribute('aria-hidden', 'true');
        check.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M4 10.5l4 4 8-8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        btn.appendChild(img);
        btn.appendChild(box);
        btn.appendChild(check);

        if (needsPicker) {
          btn.addEventListener('click', () => this._openGiftDrawer(gift.slot));
        }

        const removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'bk-media-bundle-builder__slot-remove';
        removeBtn.setAttribute('data-offer-gift-remove', String(gift.slot));
        removeBtn.hidden = true;
        removeBtn.setAttribute('aria-label', 'Entfernen');
        removeBtn.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 2l8 8M10 2L2 10" stroke="currentColor" stroke-width="1.5"/></svg>';
        removeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this._clearGift(gift.slot);
        });

        wrap.appendChild(btn);
        wrap.appendChild(removeBtn);
        this.giftSlotsEl.appendChild(wrap);
      });
    }

    _autoFillSingleVariantProductGroups() {
      if (this.flexibleQuantity) return;
      this.groups.forEach((group) => {
        if (group.source !== 'product') return;
        if (!group.items || group.items.length !== 1) return;
        const item = group.items[0];
        if (!item.available) return;
        this.selections[group.index][0] = {
          productId: item.id,
          variantId: item.variantId,
          title: item.title,
          image: item.image,
          price: item.price || 0
        };
      });
    }

    _autoFillSingleVariantGifts() {
      this.gifts.forEach((gift) => {
        if (gift.variants.length !== 1) return;
        const variant = gift.variants[0];
        if (!variant.available) return;
        this.giftSelections[gift.slot] = {
          variantId: variant.id,
          title: variant.title === 'Default Title' ? gift.title : variant.title,
          image: variant.image || gift.image,
          compareAt: parseInt(variant.compareAt, 10) || parseInt(gift.compareAt, 10) || 0
        };
      });
    }

    _createDeclineRow(group) {
      const row = document.createElement('div');
      row.className =
        'bk-media-bundle-builder__drawer-item bk-media-bundle-builder__colors-variant-row bk-media-bundle-builder__colors-variant-row--opt-in-decline';
      row.setAttribute('data-offer-decline', '');
      row.setAttribute('role', 'button');
      row.tabIndex = 0;
      if (this.drawerNone) row.classList.add('is-selected');

      const info = document.createElement('div');
      info.className = 'bk-media-bundle-builder__drawer-item-info v-stack gap-1';
      const title = document.createElement('span');
      title.className = 'text-base bk-media-bundle-builder__drawer-item-title';
      title.textContent = group.noneLabel;
      info.appendChild(title);
      row.appendChild(info);
      return row;
    }

    _openGroupDrawer(groupIndex) {
      const group = this.groups.find((g) => g.index === groupIndex);
      if (!group || !this.drawer || !this.drawerList) return;

      this.activeGroupIndex = groupIndex;
      this.drawerCapNudge = false;
      this.drawerNone = Boolean(this.declined[groupIndex]) && this._filledCount(group) === 0;
      this.drawerQuantities = {};
      (this.selections[groupIndex] || []).forEach((sel) => {
        if (!sel) return;
        const id = String(sel.variantId);
        this.drawerQuantities[id] = (this.drawerQuantities[id] || 0) + 1;
      });

      if (this.drawerTitle) {
        this.drawerTitle.textContent = group.heading || 'Wähle dein Produkt';
      }
      if (this.drawerConfirmTitle) {
        this.drawerConfirmTitle.textContent = group.heading || 'Auswahl bestätigen';
      }

      this.drawerList.innerHTML = '';
      if (group.noneLabel) {
        this.drawerList.appendChild(this._createDeclineRow(group));
      }
      group.items.forEach((item) => {
        const row = document.createElement('div');
        row.className = 'bk-media-bundle-builder__drawer-item';
        if (!item.available) row.classList.add('is-unavailable');
        row.setAttribute('data-drawer-item', '');
        row.setAttribute('data-variant-id', String(item.variantId));
        row.setAttribute('data-available', item.available ? 'true' : 'false');

        const imageWrap = document.createElement('div');
        imageWrap.className = 'bk-media-bundle-builder__drawer-item-image';
        if (item.image) {
          imageWrap.innerHTML = `<img src="${item.image}" alt="" loading="lazy" width="56" height="56">`;
        }

        const info = document.createElement('div');
        info.className = 'bk-media-bundle-builder__drawer-item-info v-stack gap-1';
        const title = document.createElement('span');
        title.className = 'text-base bk-media-bundle-builder__drawer-item-title';
        title.textContent = item.title;
        info.appendChild(title);
        if (!item.available) {
          const soldOut = document.createElement('span');
          soldOut.className = 'text-xs bk-media-bundle-builder__colors-variant-sold-out';
          soldOut.textContent = 'Ausverkauft';
          info.appendChild(soldOut);
        }

        row.appendChild(imageWrap);
        row.appendChild(info);

        if (this.qtyTemplate) {
          row.appendChild(this.qtyTemplate.content.cloneNode(true));
        }

        const plusBtn = row.querySelector('[data-qty-plus]');
        if (plusBtn && !item.available) plusBtn.disabled = true;

        this.drawerList.appendChild(row);
      });

      this._syncDrawerQtyDisplay();
      this.drawer?.show?.();
    }

    _getActiveGroup() {
      return this.groups.find((g) => g.index === this.activeGroupIndex) || null;
    }

    _getDrawerTotalQty() {
      return Object.values(this.drawerQuantities).reduce((sum, qty) => sum + qty, 0);
    }

    _changeDrawerQty(variantId, delta) {
      const group = this._getActiveGroup();
      if (!group) return;
      const max = this._groupMax(group);
      const id = String(variantId);
      const item = group.items.find((entry) => String(entry.variantId) === id);
      if (delta > 0 && (!item || !item.available)) return;

      const currentTotal = this._getDrawerTotalQty();
      const next = (this.drawerQuantities[id] || 0) + delta;
      if (delta > 0 && currentTotal >= max) {
        if (this._isCappedGroup(group)) {
          this.drawerCapNudge = true;
          this._syncDrawerQtyDisplay();
        }
        return;
      }
      if (next < 0) return;
      if (delta > 0) this.drawerNone = false;
      if (delta < 0) this.drawerCapNudge = false;

      if (next === 0) {
        delete this.drawerQuantities[id];
      } else {
        this.drawerQuantities[id] = next;
      }
      this._syncDrawerQtyDisplay();
    }

    _syncDrawerQtyDisplay() {
      const group = this._getActiveGroup();
      if (!group) return;
      const max = this._groupMax(group);
      const min = this._groupMin(group);
      const total = this._getDrawerTotalQty();
      const isExact = total === min;
      const canConfirm = this.flexibleQuantity
        ? total <= max && (total > 0 || this.drawerNone || this._filledCount(group) > 0)
        : isExact || (this.drawerNone && total === 0);

      this.drawerList?.querySelectorAll('[data-drawer-item]').forEach((item) => {
        const id = item.getAttribute('data-variant-id');
        const val = this.drawerQuantities[id] || 0;
        const input = item.querySelector('[data-qty-value]');
        if (input) {
          input.value = String(val);
          input.size = Math.max(String(val).length + 1, 2);
        }
        const minusBtn = item.querySelector('[data-qty-minus]');
        const plusBtn = item.querySelector('[data-qty-plus]');
        const isUnavailable = item.getAttribute('data-available') === 'false';
        const cappedAtMax = this._isCappedGroup(group) && total >= max;
        if (minusBtn) minusBtn.disabled = val <= 0;
        if (plusBtn) plusBtn.disabled = isUnavailable || (total >= max && !cappedAtMax);
        item.classList.toggle('is-selected', val > 0);
      });
      this.drawerList?.querySelector('[data-offer-decline]')?.classList.toggle(
        'is-selected',
        Boolean(this.drawerNone) && total === 0
      );

      if (this.drawerConfirm) this.drawerConfirm.disabled = !canConfirm;
      if (this.drawerCapHint) {
        const showCapHint = this._isCappedGroup(group) && (max < 1 || this.drawerCapNudge);
        this.drawerCapHint.hidden = !showCapHint;
        this.drawerCapHint.textContent = showCapHint ? this._capMessage(group) : '';
      }
      if (this.drawerConfirmTitle && this.drawerConfirmCount) {
        const showCount = this._isCappedGroup(group) && max > 0;
        const showSuccess = this.flexibleQuantity ? total > 0 || this.drawerNone : isExact || this.drawerNone;
        if (showCount && this.drawerTitle) {
          this.drawerTitle.textContent = `${group.heading || 'Auswahl'} · ${total}/${max}`;
        }
        if (showCount) {
          this.drawerConfirmTitle.hidden = false;
          this.drawerConfirmCount.hidden = false;
          this.drawerConfirmTitle.textContent = this.drawerNone && total === 0
            ? '🎉 Auswählen'
            : group.heading || 'Auswahl bestätigen';
          this.drawerConfirmCount.textContent = `${total}/${max}`;
          this.drawerConfirmCount.classList.add('bold');
        } else if (showSuccess) {
          this.drawerConfirmTitle.hidden = true;
          this.drawerConfirmCount.hidden = false;
          this.drawerConfirmCount.textContent = this.drawerNone && total === 0
            ? '🎉 Auswählen'
            : `🎉 Auswählen (${total})`;
          this.drawerConfirmCount.classList.add('bold');
        } else {
          this.drawerConfirmTitle.hidden = false;
          this.drawerConfirmCount.hidden = false;
          this.drawerConfirmTitle.textContent = group.heading || 'Auswahl bestätigen';
          this.drawerConfirmTitle.classList.add('bold');
          this.drawerConfirmCount.classList.remove('bold');
          this.drawerConfirmCount.textContent = `${total}/${max} ausgewählt`;
        }
      }
      this._updateDrawerPricing();
    }

    _confirmGroupDrawer() {
      const group = this._getActiveGroup();
      if (!group) return;
      const total = this._getDrawerTotalQty();
      const max = this._groupMax(group);
      const min = this._groupMin(group);
      if (this.drawerNone && total === 0) {
        this.declined[group.index] = true;
        this.selections[group.index] = [];
        this.drawer?.hide?.();
        this._updateUi();
        return;
      }

      this.declined[group.index] = false;

      if (this.flexibleQuantity) {
        if (total > max) return;
        if (total < min && total > 0) return;
        if (total === 0 && this._filledCount(group) === 0) return;
      } else if (total !== min) {
        return;
      }

      const nextSelections = [];
      Object.entries(this.drawerQuantities).forEach(([variantId, qty]) => {
        const item = group.items.find((entry) => String(entry.variantId) === String(variantId));
        if (!item || !qty) return;
        for (let i = 0; i < qty; i++) {
          nextSelections.push({
            productId: item.id,
            variantId: item.variantId,
            title: item.title,
            image: item.image,
            price: item.price || 0
          });
        }
      });

      if (this.flexibleQuantity) {
        this.selections[group.index] = nextSelections.slice(0, max);
      } else {
        while (nextSelections.length < min) nextSelections.push(null);
        this.selections[group.index] = nextSelections.slice(0, min);
      }
      this.drawer?.hide?.();
      this._updateUi();
    }

    _clearSlot(groupIndex, slotIndex) {
      if (this.declined[groupIndex] && this._filledCount({ index: groupIndex }) === 0) {
        this.declined[groupIndex] = false;
        this._updateUi();
        return;
      }
      if (!this.selections[groupIndex]) return;
      if (this.flexibleQuantity) {
        this.selections[groupIndex].splice(slotIndex, 1);
      } else {
        this.selections[groupIndex][slotIndex] = null;
      }
      this._updateUi();
    }

    _openGiftDrawer(slot) {
      const gift = this.gifts.find((g) => g.slot === slot);
      if (!gift || !this.colorsDrawer || !this.colorsList) return;

      this.activeGiftSlot = slot;
      this.pendingGiftVariantId = this.giftSelections[slot]?.variantId || null;
      if (this.colorsTitle) this.colorsTitle.textContent = gift.drawerTitle || gift.title;

      this.colorsList.innerHTML = '';
      gift.variants.forEach((variant) => {
        const row = document.createElement('button');
        row.type = 'button';
        row.className = 'bk-media-bundle-builder__drawer-item bk-media-bundle-builder__colors-variant-row';
        if (!variant.available) row.classList.add('is-unavailable');
        if (this.pendingGiftVariantId === variant.id) row.classList.add('is-selected');
        row.style.width = '100%';
        row.style.border = 'none';
        row.style.textAlign = 'left';
        row.style.cursor = variant.available ? 'pointer' : 'not-allowed';

        const imageWrap = document.createElement('div');
        imageWrap.className = 'bk-media-bundle-builder__drawer-item-image';
        if (variant.image) {
          imageWrap.innerHTML = `<img src="${variant.image}" alt="" loading="lazy" width="56" height="56">`;
        }

        const info = document.createElement('div');
        info.className = 'bk-media-bundle-builder__drawer-item-info v-stack gap-1';
        const title = document.createElement('span');
        title.className = 'text-base bk-media-bundle-builder__drawer-item-title';
        title.textContent = variant.title === 'Default Title' ? gift.title : variant.title;
        info.appendChild(title);

        row.appendChild(imageWrap);
        row.appendChild(info);

        if (variant.available) {
          row.addEventListener('click', () => {
            this.pendingGiftVariantId = variant.id;
            this.colorsList.querySelectorAll('.bk-media-bundle-builder__drawer-item').forEach((el) => {
              el.classList.toggle('is-selected', el === row);
            });
            if (this.colorsConfirm) this.colorsConfirm.disabled = false;
          });
        }

        this.colorsList.appendChild(row);
      });

      if (this.colorsConfirm) {
        this.colorsConfirm.disabled = !this.pendingGiftVariantId;
      }

      this.colorsDrawer?.show?.();
    }

    _confirmGiftColor() {
      const gift = this.gifts.find((g) => g.slot === this.activeGiftSlot);
      if (!gift || !this.pendingGiftVariantId) return;
      const variant = gift.variants.find((v) => v.id === this.pendingGiftVariantId);
      if (!variant) return;

      this.giftSelections[gift.slot] = {
        variantId: variant.id,
        title: variant.title === 'Default Title' ? gift.title : variant.title,
        image: variant.image || gift.image,
        compareAt: parseInt(variant.compareAt, 10) || parseInt(gift.compareAt, 10) || 0
      };

      this.colorsDrawer?.hide?.();
      this._updateUi();
    }

    _clearGift(slot) {
      const gift = this.gifts.find((g) => g.slot === slot);
      if (!gift || gift.variants.length <= 1) return;
      delete this.giftSelections[slot];
      this._updateUi();
    }

    _isComplete() {
      const groupsComplete = this.groups.every((group) => {
        if (this.declined[group.index]) return true;
        const filled = this._filledCount(group);
        const min = this._groupMin(group);
        const max = this._groupMax(group);
        if (this.flexibleQuantity) return filled >= min && filled <= max;
        const slots = this.selections[group.index] || [];
        return slots.length === min && slots.every(Boolean);
      });
      if (!groupsComplete) return false;
      if (this.flexibleQuantity && this._totalFilledQty() < 1) return false;

      if (!this.gifts.length) return true;

      return this.gifts.every((gift) => Boolean(this.giftSelections[gift.slot]));
    }

    _updateUi() {
      this._enforceQuantityCaps();
      this.groups.forEach((group) => this._renderGroupSlots(group));

      this.gifts.forEach((gift) => {
        const wrap = this.querySelector(`[data-gift-slot-wrap="${gift.slot}"]`);
        if (!wrap) return;
        const btn = wrap.querySelector('[data-offer-gift-slot]');
        const label = wrap.querySelector('[data-gift-slot-label]');
        const imgWrap = wrap.querySelector('[data-gift-slot-image]');
        const check = wrap.querySelector('[data-slot-check]');
        const removeBtn = wrap.querySelector('[data-offer-gift-remove]');
        const sel = this.giftSelections[gift.slot];

        if (sel) {
          btn?.classList.add('is-filled');
          if (label) {
            const normalize = (value) =>
              String(value || '')
                .replace(/^GRATIS:\s*/i, '')
                .trim()
                .toLowerCase();
            const variantLabel =
              !sel.title || sel.title === 'Default Title' ? '' : sel.title;
            const redundant =
              !variantLabel ||
              normalize(variantLabel) === normalize(gift.title) ||
              normalize(variantLabel).includes(normalize(gift.title));
            label.hidden = true;
            label.textContent = '';
            // Only show a subtitle for a distinct variant name (e.g. color), never the product title again.
            if (!redundant && gift.variants.length > 1) {
              label.hidden = false;
              label.textContent = variantLabel;
            }
          }
          if (imgWrap && sel.image) {
            imgWrap.innerHTML = `<img src="${sel.image}" alt="" loading="lazy" width="60" height="60">`;
          }
          if (check) check.setAttribute('aria-hidden', 'false');
          if (removeBtn) removeBtn.hidden = gift.variants.length <= 1;
        } else {
          btn?.classList.remove('is-filled');
          if (label) {
            label.hidden = gift.variants.length <= 1;
            label.textContent = gift.variants.length > 1 ? this.colorsPlaceholder : '';
          }
          if (imgWrap && gift.image) {
            imgWrap.innerHTML = `<img src="${gift.image}" alt="" loading="lazy" width="60" height="60">`;
          }
          if (check) check.setAttribute('aria-hidden', 'true');
          if (removeBtn) removeBtn.hidden = true;
        }
      });

      this._updateKitPricing();

      if (this.atcButton) {
        this.atcButton.disabled = !this._isComplete();
      }
    }

    _drawerPreviewLines(group) {
      const lines = [];
      Object.entries(this.drawerQuantities).forEach(([variantId, count]) => {
        const item = group.items.find((entry) => String(entry.variantId) === String(variantId));
        if (!item || !count) return;
        for (let i = 0; i < count; i++) {
          lines.push(item);
        }
      });
      return lines;
    }

    _calcPricing(options = {}) {
      const previewDrawer = Boolean(options.previewDrawer && this.activeGroupIndex);
      let subtotal = 0;
      let qty = 0;
      this.groups.forEach((group) => {
        if (group.isGoodie) return;
        const lines =
          previewDrawer && group.index === this.activeGroupIndex
            ? this._drawerPreviewLines(group)
            : this._compactSelections(group);
        lines.forEach((sel) => {
          const unit = parseInt(group.unitPrice, 10) || parseInt(sel.price, 10) || 0;
          subtotal += unit;
          qty += 1;
        });
      });

      let discountPercent = this.orderDiscountPercent || 0;
      if (this.flexibleQuantity) {
        discountPercent = this._discountPercentForQty(qty);
      }

      const discountBps = Math.round(discountPercent * 100);
      const discountCents = Math.round((subtotal * discountBps) / 10000);
      const finalCents = Math.max(0, subtotal - discountCents);
      const compareCents = subtotal;
      const savingsCents = discountCents;

      return { subtotal, finalCents, compareCents, savingsCents, qty, discountPercent };
    }

    _updateDrawerPricing() {
      if (!this.flexibleQuantity) return;
      const pricing = this._calcPricing({ previewDrawer: true });
      if (this.drawerPrices) this.drawerPrices.hidden = pricing.qty < 1;
      if (this.drawerTotal) this.drawerTotal.textContent = this._formatMoney(pricing.finalCents);
      if (this.drawerCompare) {
        this.drawerCompare.textContent = this._formatMoney(pricing.compareCents);
        this.drawerCompare.hidden = pricing.compareCents <= pricing.finalCents || pricing.qty < 1;
      }
      if (this.drawerDiscountBadge) {
        if (pricing.savingsCents > 0) {
          this.drawerDiscountBadge.textContent = `-${this._formatMoney(pricing.savingsCents)}`.replace(
            ' €',
            '\u00a0€'
          );
          this.drawerDiscountBadge.hidden = false;
        } else {
          this.drawerDiscountBadge.hidden = true;
        }
      }
      const group = this._getActiveGroup();
      const atStickerCap = Boolean(
        group && this._isCappedGroup(group) && this._getDrawerTotalQty() >= this._groupMax(group)
      );
      this._setProgress(
        this.drawerProgress,
        this.drawerProgressText,
        this.drawerProgressBadge,
        atStickerCap ? null : this._volumeProgress(pricing.qty)
      );
    }

    _updateKitPricing() {
      if (!this.flexibleQuantity) return;
      const pricing = this._calcPricing();
      this.displayFinalCents = pricing.finalCents;
      this.displayCompareCents = pricing.compareCents;

      const saleEl = this.querySelector('[data-offer-price-sale]');
      const compareEl = this.querySelector('[data-offer-compare]');
      const savingsEl = this.querySelector('[data-offer-savings]');

      if (saleEl) {
        if (pricing.qty < 1) {
          saleEl.hidden = true;
          saleEl.textContent = '';
        } else {
          saleEl.hidden = false;
          saleEl.textContent = this._formatMoney(pricing.finalCents);
        }
      }
      if (compareEl) {
        compareEl.textContent = this._formatMoney(pricing.compareCents);
        compareEl.hidden = pricing.compareCents <= pricing.finalCents || pricing.qty < 1;
      }
      if (savingsEl) {
        savingsEl.textContent = `Du sparst ${this._formatMoney(pricing.savingsCents)}`.replace(' €', '\u00a0€');
        savingsEl.hidden = pricing.savingsCents <= 0;
      }
      this._setProgress(
        this.qtyProgress,
        this.qtyProgressText,
        this.qtyProgressBadge,
        this._volumeProgress(pricing.qty)
      );
    }

    _formatMoney(cents) {
      if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
      return `${(cents / 100).toFixed(2).replace('.', ',')} €`;
    }

    _showMissingSelectionHint() {
      if (!this.atcToast) return;
      this.atcToast.hidden = false;
      this.atcToast.textContent = 'Bitte vervollständige deine Auswahl.';
      window.clearTimeout(this._toastTimer);
      this._toastTimer = window.setTimeout(() => {
        this.atcToast.hidden = true;
      }, 2500);
    }

    async _addToCart() {
      if (!this._isComplete()) {
        this._showMissingSelectionHint();
        return;
      }
      if (!this.kitVariantId) {
        alert('Kit-Variante fehlt.');
        return;
      }

      const instanceId = generateBundleInstanceId();
      const bundleId = generateBundleId(this.bundleGroup, instanceId);
      const baseProps = bundleLineProperties(
        bundleId,
        this.kitVariantId,
        this.bundleTitle,
        this.bundleGroup,
        instanceId
      );

      let giftCompareTotal = 0;
      const giftLines = [];

      const livePricing = this.flexibleQuantity ? this._calcPricing() : null;
      const listFinal = livePricing ? livePricing.finalCents : this.displayFinalCents;
      let listCompare = livePricing ? livePricing.compareCents : this.displayCompareCents;
      let customCompare = 0;
      if (this.enableCustomCompare && this.customCompareCents > listFinal) {
        customCompare = this.customCompareCents;
        listCompare = customCompare;
      }
      if (listCompare <= listFinal) listCompare = 0;

      const discountId =
        this.bundleGroup && instanceId ? `${this.bundleGroup}-${instanceId}` : bundleId;
      const addonProps = {
        _BundleId: bundleId,
        _BundleGroup: this.bundleGroup,
        _BundleInstance: instanceId,
        _BundleTitle: this.bundleTitle,
        _DiscountId: discountId
      };

      this.gifts.forEach((gift) => {
        const sel = this.giftSelections[gift.slot];
        if (!sel) return;

        const variantCompareAt = parseInt(sel.compareAt, 10) || 0;
        const giftCompareAt = variantCompareAt || parseInt(gift.compareAt, 10) || 0;
        if (giftCompareAt > 0) giftCompareTotal += giftCompareAt;

        const giftProps = {
          _BundleGift: '1',
          _BundleInstance: instanceId,
          _BundleGiftSlot: String(gift.slot),
          _BundleSlot: `gift-${gift.slot}`
        };
        if (this.bundleGroup) {
          giftProps._BundleGroup = this.bundleGroup;
        }
        if (giftCompareAt > 0 && customCompare <= 0) {
          giftProps._BundleGiftCompareAt = String(giftCompareAt);
        }
        giftLines.push({
          id: sel.variantId,
          quantity: 1,
          properties: giftProps
        });
      });

      this.groups.forEach((group) => {
        if (!group.isGoodie) return;
        (this.selections[group.index] || []).forEach((sel, slotIndex) => {
          if (!sel) return;
          const giftCompareAt =
            parseInt(group.unitPrice, 10) || parseInt(sel.price, 10) || 0;
          if (giftCompareAt > 0) giftCompareTotal += giftCompareAt;

          const giftProps = {
            _BundleGift: '1',
            _BundleInstance: instanceId,
            _BundleGiftSlot: String(group.index),
            _BundleSlot: `group-${group.index}`,
            _BundleGroupIndex: String(group.index),
            _BundleSlotIndex: String(slotIndex + 1)
          };
          if (this.bundleGroup) {
            giftProps._BundleGroup = this.bundleGroup;
          }
          if (giftCompareAt > 0 && customCompare <= 0) {
            giftProps._BundleGiftCompareAt = String(giftCompareAt);
          }
          giftLines.push({
            id: sel.variantId,
            quantity: 1,
            properties: giftProps
          });
        });
      });

      const kitProps = { ...baseProps, _BundleSlot: 'kit' };
      if (giftCompareTotal > 0 && customCompare <= 0) {
        kitProps._BundleGiftCompareTotal = String(giftCompareTotal);
      }
      if (listCompare > 0) {
        kitProps._BundleListCompareCents = String(listCompare);
      }
      if (customCompare > 0) {
        kitProps._BundleCustomCompareCents = String(customCompare);
      }
      if (listFinal > 0) {
        kitProps._BundleListFinalCents = String(listFinal);
      }

      const items = [
        {
          id: this.kitVariantId,
          quantity: 1,
          properties: kitProps
        }
      ];

      this.groups.forEach((group) => {
        if (group.isGoodie) return;
        (this.selections[group.index] || []).forEach((sel, slotIndex) => {
          if (!sel) return;
          items.push({
            id: sel.variantId,
            quantity: 1,
            properties: {
              ...addonProps,
              _BundleSlot: `group-${group.index}`,
              _BundleGroupIndex: String(group.index),
              _BundleSlotIndex: String(slotIndex + 1)
            }
          });
        });
      });

      giftLines.forEach((line) => items.push(line));

      const cartDrawerElement = document.querySelector('cart-drawer');
      const sectionId = cartDrawerElement?.getAttribute('data-section-id') || 'cart-drawer';
      let sectionsToBundle = ['variant-added'];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        })
      );
      if (!sectionsToBundle.includes(sectionId)) sectionsToBundle.push(sectionId);

      let checkoutRedirectPending = false;

      try {
        this.atcButton?.setAttribute('aria-busy', 'true');
        if (this.atcButton) this.atcButton.disabled = true;

        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items, sections: sectionsToBundle.join(',') })
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.description || 'Failed to add to cart');
        }

        const responseJson = await response.json();
        const cartContent = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();

        if (window.BkMediaBundleCartPricing?.persist && listCompare > listFinal) {
          await window.BkMediaBundleCartPricing.persist({
            bundleId,
            instanceId,
            compareCents: listCompare,
            finalCents: listFinal
          });
          const refreshedCart = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
          Object.assign(cartContent, refreshedCart);
        }

        if (!cartContent.sections) cartContent.sections = {};
        Object.assign(cartContent.sections, responseJson.sections || {});
        if (window.BkMediaBundleCartPricing?.attachFreshDrawerSection) {
          await window.BkMediaBundleCartPricing.attachFreshDrawerSection(cartContent);
        }

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', cart: cartContent }
          })
        );

        if (this.atcToast) {
          this.atcToast.hidden = false;
          this.atcToast.textContent = this.atcSuccessMessage;
        }

        if (this.redirectToCheckout) {
          checkoutRedirectPending = true;
          setTimeout(() => {
            window.location.href = `${window.Shopify.routes.root}checkout`;
          }, 1200);
          return;
        }

        const productForm = document.getElementById(this.getAttribute('data-form-id')) ||
          document.querySelector('form[is="product-form"]');
        const formToUse = productForm || document.createElement('form');
        let formAdded = false;
        if (!productForm) {
          document.body.appendChild(formToUse);
          formAdded = true;
        }

        formToUse.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: true,
            cancelable: true,
            detail: {
              items: responseJson.items || [responseJson],
              cart: cartContent
            }
          })
        );

        if (formAdded) document.body.removeChild(formToUse);
        this._resetState();
      } catch (error) {
        console.error('Bundle builder offer add to cart:', error);
        alert(error.message || 'Produkte konnten nicht hinzugefügt werden.');
      } finally {
        if (!checkoutRedirectPending) {
          this.atcButton?.removeAttribute('aria-busy');
          this._updateUi();
        }
      }
    }

    _resetState() {
      this.groups.forEach((group) => {
        const min = this._groupMin(group);
        this.selections[group.index] = this.flexibleQuantity
          ? new Array(min).fill(null)
          : new Array(group.quantity).fill(null);
      });
      this.giftSelections = {};
      this._autoFillSingleVariantProductGroups();
      this._autoFillSingleVariantGifts();
      this._updateUi();
      if (this.atcToast) {
        window.clearTimeout(this._toastTimer);
        this._toastTimer = window.setTimeout(() => {
          this.atcToast.hidden = true;
        }, 2000);
      }
    }
  }

  if (!customElements.get('bundle-builder-offer')) {
    customElements.define('bundle-builder-offer', BundleBuilderOffer);
  }

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('bundle-builder-offer').forEach((el) => {
      if (typeof el.connectedCallback === 'function') el.connectedCallback();
    });
  });
})();
